var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Star = function Star(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M12.89 1.56a1 1 0 0 0-1.794 0L8.243 7.34l-6.38.925a1 1 0 0 0-.553 1.707l4.622 4.5-1.09 6.354a1 1 0 0 0 1.451 1.054l5.706-3 5.693 3a1 1 0 0 0 1.452-1.054l-1.09-6.354 4.623-4.5a1 1 0 0 0-.555-1.707l-6.379-.924-2.853-5.782Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Star;